import { useSearchParams } from 'react-router-dom';
import { FilterChips } from '../../../shared/components';

const FilterPills = ({ filtersView, setfiltersView ,setFilters ,clearFilters, setDefaultSample, filterData }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const removeFilter = (filterId) => {
     const updates = {};
        const categoryFilter = filterId==1;
        const brandValuesFilter = filterId==2;
        const tagsFilter = filtersView.find(f => typeof f.id === 'string' && f.id.startsWith("group-"));
        const sampleFilter = filterId==3;
        const priceFilter = filterId==4;
        if (categoryFilter) updates.categories = [];
        if (brandValuesFilter) {
          updates.brandValues = [];
          updates.vendorValues = [];
        }
        if (tagsFilter && typeof filterId === 'string') {
          // Only remove tags from the specific group being removed
          const groupCode = filterId.replace("group-", "");
          const groupTags = filterData?.tagGroups?.find(group => group.code === groupCode)?.tags?.map(tag => tag.code) || [];
          updates.tags = (prevTags) => prevTags.filter(tag => !groupTags.includes(tag));
        }
        if (sampleFilter){
          updates.sample = [];
          if(setDefaultSample) setDefaultSample('');
        }
        if (priceFilter) updates.priceRange = [];

        if (Object.keys(updates).length) {
          setFilters(prev => {
            const newFilters = { ...prev };
            Object.keys(updates).forEach(key => {
              if (typeof updates[key] === 'function') {
                newFilters[key] = updates[key](prev[key]);
              } else {
                newFilters[key] = updates[key];
              }
            });
            return newFilters;
          });
        }
    
    setfiltersView(filtersView.filter(filter => filter.id !== filterId));
    switch (filterId) {
      case 1:
        setSearchParams(prev => {
          const params = Object.fromEntries(prev);
          delete params.category;
          delete params.subcategory;
          return params;
        });
        break;
      case 2:
        setSearchParams(prev => {
          const params = Object.fromEntries(prev);
          delete params.brand_values; // remove ONLY brand_values
          delete params.brands; // remove ONLY brands
          delete params.vendors; // remove ONLY vendors
          return params;
        });
        break;
      case 3:
        setSearchParams(prev => {
          const params = Object.fromEntries(prev);
          delete params.hassample; // remove ONLY hassample
          return params;
        });
        break;
      case 4:
        setSearchParams(prev => {
          const params = Object.fromEntries(prev);
          delete params.price; // remove ONLY price
          return params;
        });
        break;
      default:
        if(typeof filterId === 'string'){
          const filterTag = filterId.replace("group-", "");
          setSearchParams(prev => {
            const params = Object.fromEntries(prev);
            delete params?.[filterTag]; // remove ONLY filterTag
            return params;
          });
        }
        break;
    }
  };

  const clearAll = () => {
    setfiltersView([]);
    clearFilters();
    setSearchParams({})
  };

  /* The markup is `FilterChips`; the removal logic stays here. A chip on this
     page stands for a whole GROUP of values — "Brand: Acme, Zenith" is one pill —
     so removing it has to unpick both `filters` and the URL, and only this
     component knows how a group maps onto either.

     It returns null when nothing is applied (`FilterChips` does that for us): an
     empty `.br-chips` still spends its 16px bottom margin. */
  return (
    <FilterChips
      chips={filtersView.map((filter) => ({
        id: filter.id,
        group: filter.label,
        label: filter.value,
        onRemove: removeFilter,
      }))}
      onClearAll={clearAll}
    />
  );
};

export default FilterPills;
